/* eslint-disable @next/next/no-img-element */
import React from 'react'

import { IconProps } from './Icon.types'

const Icon = ({ alt, height, src, width }: IconProps) => {
  return (
    <img
      alt={alt}
      height={height}
      src={src}
      width={width}
    />
  )
}

export default Icon